import React from "react";

function Eth() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 48 48"
      width={48}
      height={48}
    >
      <path
        fill="url(#a)"
        d="M1.09 5.46C0 7.6 0 10.4 0 16v16c0 5.6 0 8.4 1.09 10.54a10 10 0 004.37 4.37C7.6 48 10.4 48 16 48h16c1.752 0 3.23 0 4.5-.033 0-1.362 0-2.044.066-2.616a10 10 0 018.785-8.785c.572-.066 1.254-.066 2.616-.066C48 35.23 48 33.752 48 32V16c0-5.6 0-8.4-1.09-10.54a10 10 0 00-4.37-4.37C40.4 0 37.6 0 32 0H16C10.4 0 7.6 0 5.46 1.09a10 10 0 00-4.37 4.37z"
      ></path>
      <path
        fill="url(#b)"
        d="M1.09 5.46C0 7.6 0 10.4 0 16v16c0 5.6 0 8.4 1.09 10.54a10 10 0 004.37 4.37C7.6 48 10.4 48 16 48h16c1.752 0 3.23 0 4.5-.033 0-1.362 0-2.044.066-2.616a10 10 0 018.785-8.785c.572-.066 1.254-.066 2.616-.066C48 35.23 48 33.752 48 32V16c0-5.6 0-8.4-1.09-10.54a10 10 0 00-4.37-4.37C40.4 0 37.6 0 32 0H16C10.4 0 7.6 0 5.46 1.09a10 10 0 00-4.37 4.37z"
      ></path>
      <path
        fill="#000"
        fillOpacity="0.04"
        fillRule="evenodd"
        d="M35.5 35.5h11.486C47 34.475 47 33.32 47 32V16c0-2.817 0-4.87-.133-6.487-.131-1.605-.387-2.694-.848-3.599a9 9 0 00-3.933-3.933c-.905-.461-1.994-.717-3.6-.848C36.87 1 34.816 1 32 1H16c-2.817 0-4.87 0-6.487.133-1.605.131-2.694.387-3.599.848a9 9 0 00-3.933 3.933c-.461.905-.717 1.994-.848 3.6C1 11.13 1 13.183 1 16v16c0 2.817 0 4.87.133 6.486.131 1.606.387 2.695.848 3.6a9 9 0 003.933 3.933c.905.461 1.994.717 3.6.848C11.13 47 13.183 47 16 47h16c1.32 0 2.475 0 3.5-.014V35.5zm1 12.467C35.23 48 33.752 48 32 48H16c-5.6 0-8.4 0-10.54-1.09a10 10 0 01-4.37-4.37C0 40.4 0 37.6 0 32V16c0-5.6 0-8.4 1.09-10.54a10 10 0 014.37-4.37C7.6 0 10.4 0 16 0h16c5.6 0 8.4 0 10.54 1.09a10 10 0 014.37 4.37C48 7.6 48 10.4 48 16v16c0 1.752 0 3.23-.033 4.5H36.5v11.467z"
        clipRule="evenodd"
      ></path>
      <path
        fill="#000"
        fillOpacity="0.8"
        d="M3 14.2c0-3.92 0-5.88.763-7.378a7 7 0 013.06-3.059C8.318 3 10.28 3 14.2 3h19.6c3.92 0 5.88 0 7.378.763a7 7 0 013.059 3.06C45 8.318 45 10.28 45 14.2v19.6c0 3.92 0 5.88-.763 7.378a7 7 0 01-3.06 3.059C39.682 45 37.72 45 33.8 45H14.2c-3.92 0-5.88 0-7.378-.763a7 7 0 01-3.059-3.06C3 39.682 3 37.72 3 33.8V14.2z"
      ></path>
      <path
        fill="#000"
        fillRule="evenodd"
        d="M33.8 3.5H14.2c-1.968 0-3.415 0-4.557.094-1.136.093-1.927.275-2.594.614A6.5 6.5 0 004.21 7.05c-.34.667-.522 1.458-.615 2.594C3.5 10.785 3.5 12.232 3.5 14.2v19.6c0 1.968 0 3.415.094 4.557.093 1.136.275 1.928.614 2.594a6.5 6.5 0 002.841 2.84c.667.34 1.458.522 2.594.615 1.142.094 2.589.094 4.557.094h19.6c1.968 0 3.415 0 4.557-.094 1.136-.093 1.928-.275 2.594-.614a6.499 6.499 0 002.84-2.841c.34-.666.522-1.458.615-2.594.094-1.142.094-2.589.094-4.557V14.2c0-1.968 0-3.415-.094-4.557-.093-1.136-.275-1.927-.614-2.594a6.5 6.5 0 00-2.841-2.84c-.666-.34-1.458-.522-2.594-.615C37.215 3.5 35.768 3.5 33.8 3.5zM3.763 6.822C3 8.32 3 10.28 3 14.2v19.6c0 3.92 0 5.88.763 7.378a7 7 0 003.06 3.059C8.318 45 10.28 45 14.2 45h19.6c3.92 0 5.88 0 7.378-.763a7 7 0 003.059-3.06C45 39.682 45 37.72 45 33.8V14.2c0-3.92 0-5.88-.763-7.378a7 7 0 00-3.06-3.059C39.682 3 37.72 3 33.8 3H14.2c-3.92 0-5.88 0-7.378.763a7 7 0 00-3.059 3.06z"
        clipRule="evenodd"
      ></path>
      <path
        fill="#DFD7D5"
        d="M25 13c0-2.8 0-4.2.545-5.27a5 5 0 012.185-2.185C28.8 5 30.2 5 33 5h2c2.8 0 4.2 0 5.27.545a5 5 0 012.185 2.185C43 8.8 43 10.2 43 13v2c0 2.8 0 4.2-.545 5.27a5 5 0 01-2.185 2.185C39.2 23 37.8 23 35 23h-2c-2.8 0-4.2 0-5.27-.545a5 5 0 01-2.185-2.185C25 19.2 25 17.8 25 15v-2z"
      ></path>
      <path
        fill="#E1D7D5"
        d="M38 5h-8a5 5 0 00-5 5v8a5 5 0 005 5h8a5 5 0 005-5v-8a5 5 0 00-5-5z"
      ></path>
      <path
        fill="#D22209"
        d="M37.938 16.813h-7.876v.562h7.875v-.563zm0 .562h-7.876v.563h7.875v-.563z"
      ></path>
      <path
        fill="#D22209"
        d="M37.938 17.938h-7.876v.562h7.875v-.563zm0 .562h-7.876v.563h7.875V18.5z"
      ></path>
      <path
        fill="#D22209"
        d="M31.188 19.063h-1.125v.562h1.125v-.563zm6.75 0H31.75v.562h6.188v-.563zm-6.75.562h-1.125v.563h1.125v-.563zm6.75 0H31.75v.563h6.188v-.563z"
      ></path>
      <path
        fill="#D22209"
        d="M31.188 20.188h-1.125v.562h1.125v-.563zm6.75 0H31.75v.562h6.188v-.563zm-6.75.562h-1.125v.563h1.125v-.563zm6.75 0H31.75v.563h6.188v-.563z"
      ></path>
      <path
        fill="#D22209"
        d="M31.188 21.313h-1.125v.562h1.125v-.563zm6.75 0H31.75v.562h6.188v-.563zm-6.75.562h-1.125v.563h1.125v-.563zm6.75 0H31.75v.563h6.188v-.563z"
      ></path>
      <path
        fill="#D22209"
        d="M31.188 22.438h-1.125V23h1.125v-.563zm6.75 0H31.75V23h6.188v-.563z"
      ></path>
      <path
        fill="#fff"
        d="M32.875 17.938h-.563v.562h.563v-.563zm2.25 0H34v.562h1.125v-.563zm1.125 0h-.563v.562h.563v-.563zm-3.375.562h-.563v.563h.563V18.5zm2.25 0H34v.563h1.125V18.5zm1.125 0h-.563v.563h.563V18.5z"
      ></path>
      <path
        fill="#fff"
        d="M33.438 19.063h-1.126v.562h1.126v-.563zm1.687 0H34v.562h1.125v-.563zm1.688 0h-1.126v.562h1.126v-.563z"
      ></path>
      <path
        fill="#C16710"
        d="M33.438 8.375h-.563v.563h.563v-.563zm1.687 0H34v.563h1.125v-.563z"
      ></path>
      <path fill="#D4A015" d="M31.75 8.938h-1.688V9.5h1.688v-.563z"></path>
      <path fill="#C16710" d="M35.688 8.938h-3.376V9.5h3.376v-.563z"></path>
      <path fill="#D4A015" d="M37.938 8.938H36.25V9.5h1.688v-.563z"></path>
      <path fill="#C16710" d="M30.063 9.5h-1.125v.563h1.125V9.5z"></path>
      <path fill="#D4A015" d="M31.75 9.5h-1.688v.563h1.688V9.5z"></path>
      <path fill="#C16710" d="M35.125 9.5H31.75v.563h3.375V9.5z"></path>
      <path fill="#D4A015" d="M37.938 9.5H36.25v.563h1.688V9.5z"></path>
      <path fill="#C16710" d="M30.063 10.063h-1.125v.562h1.125v-.563z"></path>
      <path fill="#D4A015" d="M34 10.063h-3.938v.562H34v-.563z"></path>
      <path fill="#C16710" d="M34.563 10.063H34v.562h.563v-.563z"></path>
      <path fill="#D4A015" d="M37.938 10.063h-3.376v.562h3.376v-.563z"></path>
      <path fill="#C16710" d="M30.063 10.625h-1.688v.563h1.688v-.563z"></path>
      <path fill="#D4A015" d="M33.438 10.625h-3.376v.563h3.375v-.563z"></path>
      <path fill="#FFE939" d="M35.125 10.625h-1.688v.563h1.688v-.563z"></path>
      <path fill="#D4A015" d="M37.938 10.625h-2.813v.563h2.813v-.563z"></path>
      <path fill="#C16710" d="M30.063 11.188h-1.125v.562h1.125v-.563z"></path>
      <path fill="#D4A015" d="M34 11.188h-3.938v.562H34v-.563z"></path>
      <path fill="#FFE939" d="M34.563 11.188H34v.562h.563v-.563z"></path>
      <path fill="#D4A015" d="M37.938 11.188h-3.376v.562h3.376v-.563z"></path>
      <path fill="#C16710" d="M30.063 11.75h-1.125v.563h1.125v-.563z"></path>
      <path fill="#D4A015" d="M34 11.75h-3.938v.563H34v-.563z"></path>
      <path fill="#FFE939" d="M34.563 11.75H34v.563h.563v-.563z"></path>
      <path fill="#D4A015" d="M37.938 11.75h-3.376v.563h3.376v-.563z"></path>
      <path fill="#C16710" d="M30.063 12.313h-1.688v.562h1.688v-.563z"></path>
      <path fill="#D4A015" d="M34 12.313h-3.938v.562H34v-.563z"></path>
      <path fill="#FFE939" d="M34.563 12.313H34v.562h.563v-.563z"></path>
      <path fill="#D4A015" d="M37.938 12.313h-3.376v.562h3.376v-.563z"></path>
      <path fill="#C16710" d="M30.063 12.875h-1.125v.563h1.125v-.563z"></path>
      <path fill="#D4A015" d="M34 12.875h-3.938v.563H34v-.563z"></path>
      <path fill="#FFE939" d="M34.563 12.875H34v.563h.563v-.563z"></path>
      <path fill="#D4A015" d="M37.938 12.875h-3.376v.563h3.376v-.563z"></path>
      <path fill="#C16710" d="M30.063 13.438h-1.125V14h1.125v-.563z"></path>
      <path fill="#D4A015" d="M34 13.438h-3.938V14H34v-.563z"></path>
      <path fill="#FFE939" d="M34.563 13.438H34V14h.563v-.563z"></path>
      <path fill="#D4A015" d="M37.938 13.438h-3.376V14h3.376v-.563z"></path>
      <path fill="#C16710" d="M30.063 14h-1.688v.563h1.688V14z"></path>
      <path fill="#D08B11" d="M40.188 14H30.062v.563h10.125V14z"></path>
      <path fill="#C16710" d="M30.063 14.563h-1.125v.562h1.125v-.563z"></path>
      <path fill="#D08B11" d="M37.938 14.563h-7.876v.562h7.875v-.563z"></path>
      <path fill="#000" d="M38.5 14.563h-.563v.562h.563v-.563z"></path>
      <path fill="#D08B11" d="M39.063 14.563H38.5v.562h.563v-.563z"></path>
      <path fill="#000" d="M39.625 14.563h-.563v.562h.563v-.563z"></path>
      <path fill="#D08B11" d="M40.188 14.563h-.563v.562h.563v-.563z"></path>
      <path fill="#C16710" d="M30.063 15.125h-1.688v.563h1.688v-.563z"></path>
      <path fill="#D08B11" d="M31.188 15.125h-1.125v.563h1.125v-.563z"></path>
      <path fill="#FFE939" d="M31.75 15.125h-.563v.563h.563v-.563z"></path>
      <path fill="#000" d="M32.313 15.125h-.563v.563h.563v-.563z"></path>
      <path fill="#FFE939" d="M32.875 15.125h-.563v.563h.563v-.563z"></path>
      <path fill="#000" d="M33.438 15.125h-.563v.563h.563v-.563z"></path>
      <path fill="#FFE939" d="M34 15.125h-.563v.563H34v-.563z"></path>
      <path fill="#000" d="M34.563 15.125H34v.563h.563v-.563z"></path>
      <path fill="#FFE939" d="M35.125 15.125h-.563v.563h.563v-.563z"></path>
      <path fill="#D08B11" d="M40.188 15.125h-5.063v.563h5.063v-.563z"></path>
      <path fill="#C16710" d="M30.063 15.688h-2.25v.562h2.25v-.563z"></path>
      <path fill="#D08B11" d="M40.188 15.688H30.062v.562h10.125v-.563z"></path>
      <path fill="#C16710" d="M30.063 16.25h-1.688v.563h1.688v-.563z"></path>
      <path fill="#D08B11" d="M40.188 16.25H30.062v.563h10.125v-.563z"></path>
      <path
        fill="#C16710"
        d="M28.938 16.813h-.563v.562h.563v-.563zm1.125 0H29.5v.562h.563v-.563z"
      ></path>
      <path fill="#D08B11" d="M37.938 16.813h-7.876v.562h7.875v-.563z"></path>
      <path
        fill="#B9185C"
        d="M34 11.188h-3.375v.562H34v-.563zm3.938 0h-3.376v.562h3.376v-.563zm-6.75.562h-.563v.563h.563v-.563z"
      ></path>
      <path fill="#fff" d="M32.313 11.75h-1.126v.563h1.125v-.563z"></path>
      <path fill="#000" d="M33.438 11.75h-1.126v.563h1.126v-.563z"></path>
      <path
        fill="#B9185C"
        d="M34 11.75h-.563v.563H34v-.563zm1.125 0h-.563v.563h.563v-.563z"
      ></path>
      <path fill="#fff" d="M36.25 11.75h-1.125v.563h1.125v-.563z"></path>
      <path fill="#000" d="M37.375 11.75H36.25v.563h1.125v-.563z"></path>
      <path
        fill="#B9185C"
        d="M37.938 11.75h-.563v.563h.563v-.563zm-6.75.563h-2.25v.562h2.25v-.563z"
      ></path>
      <path fill="#fff" d="M32.313 12.313h-1.126v.562h1.125v-.563z"></path>
      <path fill="#000" d="M33.438 12.313h-1.126v.562h1.126v-.563z"></path>
      <path fill="#B9185C" d="M35.125 12.313h-1.688v.562h1.688v-.563z"></path>
      <path fill="#fff" d="M36.25 12.313h-1.125v.562h1.125v-.563z"></path>
      <path fill="#000" d="M37.375 12.313H36.25v.562h1.125v-.563z"></path>
      <path
        fill="#B9185C"
        d="M37.938 12.313h-.563v.562h.563v-.563zm-8.438.562h-.563v.563h.563v-.563zm1.688 0h-.563v.563h.563v-.563z"
      ></path>
      <path fill="#fff" d="M32.313 12.875h-1.126v.563h1.125v-.563z"></path>
      <path fill="#000" d="M33.438 12.875h-1.126v.563h1.126v-.563z"></path>
      <path
        fill="#B9185C"
        d="M34 12.875h-.563v.563H34v-.563zm1.125 0h-.563v.563h.563v-.563z"
      ></path>
      <path fill="#fff" d="M36.25 12.875h-1.125v.563h1.125v-.563z"></path>
      <path fill="#000" d="M37.375 12.875H36.25v.563h1.125v-.563z"></path>
      <path
        fill="#B9185C"
        d="M37.938 12.875h-.563v.563h.563v-.563zm-8.438.563h-.563V14h.563v-.563zm1.688 0h-.563V14h.563v-.563z"
      ></path>
      <path fill="#fff" d="M32.313 13.438h-1.126V14h1.125v-.563z"></path>
      <path fill="#000" d="M33.438 13.438h-1.126V14h1.126v-.563z"></path>
      <path
        fill="#B9185C"
        d="M34 13.438h-.563V14H34v-.563zm1.125 0h-.563V14h.563v-.563z"
      ></path>
      <path fill="#fff" d="M36.25 13.438h-1.125V14h1.125v-.563z"></path>
      <path fill="#000" d="M37.375 13.438H36.25V14h1.125v-.563z"></path>
      <path
        fill="#B9185C"
        d="M37.938 13.438h-.563V14h.563v-.563zM34 14h-3.375v.563H34V14zm3.938 0h-3.376v.563h3.376V14z"
      ></path>
      <path
        fill="#fff"
        fillOpacity="0.3"
        fillRule="evenodd"
        d="M35 5.5h-2c-1.408 0-2.435 0-3.243.066-.803.066-1.347.194-1.8.424a4.5 4.5 0 00-1.966 1.967c-.231.453-.359.997-.424 1.8-.067.808-.067 1.835-.067 3.243v2c0 1.408 0 2.435.067 3.243.065.803.193 1.347.424 1.8a4.5 4.5 0 001.966 1.966c.453.231.997.359 1.8.424.808.067 1.835.067 3.243.067h2c1.408 0 2.435 0 3.243-.067.803-.065 1.347-.193 1.8-.424a4.5 4.5 0 001.967-1.966c.23-.453.358-.997.424-1.8.066-.808.066-1.835.066-3.243v-2c0-1.408 0-2.435-.066-3.243-.066-.803-.194-1.347-.424-1.8a4.5 4.5 0 00-1.967-1.967c-.453-.23-.997-.358-1.8-.424C37.435 5.5 36.408 5.5 35 5.5zm-9.455 2.23C25 8.8 25 10.2 25 13v2c0 2.8 0 4.2.545 5.27a5 5 0 002.185 2.185C28.8 23 30.2 23 33 23h2c2.8 0 4.2 0 5.27-.545a5 5 0 002.185-2.185C43 19.2 43 17.8 43 15v-2c0-2.8 0-4.2-.545-5.27a5 5 0 00-2.185-2.185C39.2 5 37.8 5 35 5h-2c-2.8 0-4.2 0-5.27.545a5 5 0 00-2.185 2.185z"
        clipRule="evenodd"
      ></path>
      <path
        fill="#564CBF"
        d="M5 33c0-2.8 0-4.2.545-5.27a5 5 0 012.185-2.185C8.8 25 10.2 25 13 25h2c2.8 0 4.2 0 5.27.545a5 5 0 012.185 2.185C23 28.8 23 30.2 23 33v2c0 2.8 0 4.2-.545 5.27a5 5 0 01-2.185 2.185C19.2 43 17.8 43 15 43h-2c-2.8 0-4.2 0-5.27-.545a5 5 0 01-2.185-2.185C5 39.2 5 37.8 5 35v-2z"
      ></path>
      <path
        fill="#FF66B3"
        d="M11.188 26.125h.562v2.813h.563v-2.813h.562V29.5h.563v-3.375H14V29.5h.563v-3.375h.562v2.813h.563v-2.813h.562v2.25h.563v-1.688h.562v2.25h-.563v.563h-.562v.563h-1.125v.562h-2.813v-.563h-1.124V29.5h-.563v-.563h-.563v-2.25h.563v1.688h.563v-2.25z"
      ></path>
      <path
        fill="#B3FFCC"
        d="M13.438 30.625H14v.563h1.125v2.25h1.125v-.563h.563V34h-1.688v1.125h-.563v1.125h.563v5.625h-.563v-5.063H14v-.562h-1.688v-1.125h.563v.563H14v-1.126h.563V31.75h-1.126v-1.125z"
      ></path>
      <path
        fill="#000"
        fillOpacity="0.9"
        d="M16.25 26.125h.563v2.25h-.563v-2.25zm-5.625.563h.563v1.687h-.563v-1.688z"
      ></path>
      <path
        fill="#000"
        fillOpacity="0.9"
        d="M17.938 26.688h-.563v2.25h-.563v.562h-.562v.563h.563V29.5h.562v-.563h.563v-2.25zm-6.188-.563h.563v2.813h-.563v-2.813zm3.938 0h-.563v2.813h.563v-2.813zm-2.813 0h.563V29.5h-.563v-3.375zm1.688 0H14V29.5h.563v-3.375zm.562 3.938h.563v.562h-.563v-.563zm-.562.562H14v.563h.563v-.563zm.562.563h.563v2.25h-.563v-2.25zm2.25 1.687h-.563V34h.563v-1.125zM15.125 34h.563v1.125h-.563V34zm0 2.25v-1.125h-.563v1.125h.563zm0 0v5.625h.563V36.25h-.563zm-2.25-1.125h.563v.563h-.563v-.563z"
      ></path>
      <path
        fill="#fff"
        fillOpacity="0.12"
        fillRule="evenodd"
        d="M15 25.5h-2c-1.408 0-2.435 0-3.243.067-.803.065-1.347.193-1.8.424a4.5 4.5 0 00-1.967 1.966c-.23.453-.358.997-.424 1.8C5.5 30.565 5.5 31.592 5.5 33v2c0 1.408 0 2.435.066 3.243.066.803.194 1.347.424 1.8a4.5 4.5 0 001.967 1.967c.453.23.997.358 1.8.424.808.066 1.835.066 3.243.066h2c1.408 0 2.435 0 3.243-.066.803-.066 1.347-.194 1.8-.424a4.5 4.5 0 001.966-1.967c.231-.453.359-.997.424-1.8.067-.808.067-1.835.067-3.243v-2c0-1.408 0-2.435-.067-3.243-.065-.803-.193-1.347-.424-1.8a4.5 4.5 0 00-1.966-1.966c-.453-.231-.997-.359-1.8-.424-.808-.067-1.835-.067-3.243-.067zm-9.455 2.23C5 28.8 5 30.2 5 33v2c0 2.8 0 4.2.545 5.27a5 5 0 002.185 2.185C8.8 43 10.2 43 13 43h2c2.8 0 4.2 0 5.27-.545a5 5 0 002.185-2.185C23 39.2 23 37.8 23 35v-2c0-2.8 0-4.2-.545-5.27a5 5 0 00-2.185-2.185C19.2 25 17.8 25 15 25h-2c-2.8 0-4.2 0-5.27.545a5 5 0 00-2.185 2.185z"
        clipRule="evenodd"
      ></path>
      <path
        fill="#172D99"
        d="M5 13c0-2.8 0-4.2.545-5.27A5 5 0 017.73 5.545C8.8 5 10.2 5 13 5h2c2.8 0 4.2 0 5.27.545a5 5 0 012.185 2.185C23 8.8 23 10.2 23 13v2c0 2.8 0 4.2-.545 5.27a5 5 0 01-2.185 2.185C19.2 23 17.8 23 15 23h-2c-2.8 0-4.2 0-5.27-.545a5 5 0 01-2.185-2.185C5 19.2 5 17.8 5 15v-2z"
      ></path>
      <path
        fill="#00A2D8"
        fillRule="evenodd"
        d="M11.3 13.1H8.6v.9h2.7v-.9zm0 .9h1.8v.9h.9v1.8h-.9v-.9h-.9v-.9h-.9V14zm2.7 2.7h.9v2.7H14v-2.7z"
        clipRule="evenodd"
      ></path>
      <path
        fill="#00DE6F"
        fillRule="evenodd"
        d="M11.3 12.2H8.6v.9h2.7v-.9zm0 .9h1.8v.9h-1.8v-.9zm2.7 1.8h-.9V14h.9v.9zm.9 1.8H14v-1.8h.9v1.8zm0 0h.9v2.7h-.9v-2.7z"
        clipRule="evenodd"
      ></path>
      <path
        fill="#FFEB00"
        fillRule="evenodd"
        d="M11.3 11.3H8.6v.9h2.7v-.9zm0 .9h1.8v.9h-1.8v-.9zM14 14h-.9v-.9h.9v.9zm.9.9H14V14h.9v.9zm.9 1.8h-.9v-1.8h.9v1.8zm0 0h.9v2.7h-.9v-2.7z"
        clipRule="evenodd"
      ></path>
      <path
        fill="#FA0"
        fillRule="evenodd"
        d="M11.3 10.4H8.6v.9h2.7v-.9zm0 .9H14v.9h.9v.9h.9v.9h.9v1.8h.9v3.6h-.9v-2.7h-.9v-1.8h-.9V14H14v-.9h-.9v-.9h-1.8v-.9z"
        clipRule="evenodd"
      ></path>
      <path
        fill="#DD3D1C"
        fillRule="evenodd"
        d="M12.2 9.5H8.6v.9h2.7v.9H14v.9h.9v.9h.9v.9h.9v1.8h.9v3.6h.9v-3.6h-.9V14h-.9v-.9h-.9v-.9h-.9v-.9H14v-.9h-1.8v-.9z"
        clipRule="evenodd"
      ></path>
      <path
        fill="#C03078"
        fillRule="evenodd"
        d="M12.2 8.6H8.6v.9h3.6v-.9zm0 .9H14v.9h-1.8v-.9zm5.4 4.5h-.9v-.9h-.9v-.9h-.9v-.9H14v-.9h1.8v.9h.9v.9h.9V14zm.9 1.8h-.9V14h.9v1.8zm0 0h.9v3.6h-.9v-3.6z"
        clipRule="evenodd"
      ></path>
      <path
        fill="#fff"
        fillOpacity="0.12"
        fillRule="evenodd"
        d="M15 5.5h-2c-1.408 0-2.435 0-3.243.066-.803.066-1.347.194-1.8.424A4.5 4.5 0 005.99 7.957c-.23.453-.358.997-.424 1.8C5.5 10.565 5.5 11.592 5.5 13v2c0 1.408 0 2.435.066 3.243.066.803.194 1.347.424 1.8a4.5 4.5 0 001.967 1.966c.453.231.997.359 1.8.424.808.067 1.835.067 3.243.067h2c1.408 0 2.435 0 3.243-.067.803-.065 1.347-.193 1.8-.424a4.5 4.5 0 001.966-1.966c.231-.453.359-.997.424-1.8.067-.808.067-1.835.067-3.243v-2c0-1.408 0-2.435-.067-3.243-.065-.803-.193-1.347-.424-1.8a4.5 4.5 0 00-1.966-1.967c-.453-.23-.997-.358-1.8-.424C17.435 5.5 16.408 5.5 15 5.5zM5.545 7.73C5 8.8 5 10.2 5 13v2c0 2.8 0 4.2.545 5.27a5 5 0 002.185 2.185C8.8 23 10.2 23 13 23h2c2.8 0 4.2 0 5.27-.545a5 5 0 002.185-2.185C23 19.2 23 17.8 23 15v-2c0-2.8 0-4.2-.545-5.27a5 5 0 00-2.185-2.185C19.2 5 17.8 5 15 5h-2c-2.8 0-4.2 0-5.27.545A5 5 0 005.545 7.73z"
        clipRule="evenodd"
      ></path>
      <path
        fill="#99B3FF"
        d="M48 36.5C48 42.851 42.851 48 36.5 48S25 42.851 25 36.5 30.149 25 36.5 25 48 30.149 48 36.5z"
      ></path>
      <path
        fill="#000"
        fillOpacity="0.12"
        fillRule="evenodd"
        d="M36.5 47.5c6.075 0 11-4.925 11-11s-4.925-11-11-11-11 4.925-11 11 4.925 11 11 11zm0 .5C42.851 48 48 42.851 48 36.5S42.851 25 36.5 25 25 30.149 25 36.5 30.149 48 36.5 48z"
        clipRule="evenodd"
      ></path>
      <path
        fill="#7F91EB"
        d="M46 36.5a9.5 9.5 0 11-19 0 9.5 9.5 0 0119 0z"
      ></path>
      <path
        fill="#000"
        fillOpacity="0.12"
        fillRule="evenodd"
        d="M36.5 45.5a9 9 0 100-18 9 9 0 000 18zm0 .5a9.5 9.5 0 100-19 9.5 9.5 0 000 19z"
        clipRule="evenodd"
      ></path>
      <path
        fill="#fff"
        fillOpacity="0.2"
        fillRule="evenodd"
        d="M31.912 37.037a.5.5 0 01-.139-.665l4.298-7.13a.5.5 0 01.856 0l4.297 7.13a.5.5 0 01-.137.664.5.5 0 01.119.698l-4.3 6.055a.5.5 0 01-.815 0l-4.297-6.055a.5.5 0 01.118-.697zm.29.408l4.297 2.538 4.3-2.538-4.3 6.055-4.297-6.055zm0-.815l4.297-7.13 4.297 7.13-4.297 2.54-4.297-2.54z"
        clipRule="evenodd"
      ></path>
      <path
        fill="#000"
        fillOpacity="0.55"
        d="M36.499 29.5v9.67l4.297-2.54-4.297-7.13z"
      ></path>
      <path
        fill="#000"
        fillOpacity="0.3"
        d="M36.499 29.5l-4.297 7.13 4.297 2.54V29.5z"
      ></path>
      <path
        fill="#000"
        fillOpacity="0.55"
        d="M36.499 39.983V43.5l4.3-6.055-4.3 2.538z"
      ></path>
      <path
        fill="#000"
        fillOpacity="0.3"
        d="M36.499 43.5v-3.517l-4.297-2.538 4.297 6.055z"
      ></path>
      <path fill="#000" d="M36.499 39.17l4.297-2.54-4.297-1.953v4.493z"></path>
      <path
        fill="#000"
        fillOpacity="0.6"
        d="M32.202 36.63l4.297 2.54v-4.493l-4.297 1.953z"
      ></path>
      <defs>
        <linearGradient
          id="a"
          x1="24"
          x2="24"
          y1="0"
          y2="48"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#174299"></stop>
          <stop offset="1" stopColor="#001E59"></stop>
        </linearGradient>
        <linearGradient
          id="b"
          x1="24"
          x2="24"
          y1="0"
          y2="48"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#D2D8E4"></stop>
          <stop offset="1" stopColor="#C2C9D6"></stop>
        </linearGradient>
      </defs>
    </svg>
  );
}

export default Eth;
